import React from 'react'

interface IProps {}

const MobileNavigationSpace: React.FC<IProps> = ({}) => {
    return (
        <div
            className={
                'bg-gray09 dark:bg-bg_dark_white02 h-[10px] border-t border-t-gray07 dark:border-t-dark_gray07'
            }></div>
    )
}

export default MobileNavigationSpace
